import './sam/application';
import './sam/formHelper';
import './sam/tabLinks';

jQuery(function ($) {
  $('.sam_phone').mask('(999) 999-9999', {placeholder: '(   )    -    '});
});
